import { render, staticRenderFns } from "./TableFieldConfiguratorColumn.vue?vue&type=template&id=3db477e2&"
import script from "./TableFieldConfiguratorColumn.vue?vue&type=script&lang=js&"
export * from "./TableFieldConfiguratorColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports